export default "__VITE_ASSET__D9ZIsIh7__"